// Цвета, которые не входят в основную цветовую схему
// Эти цвета используются для специфичных функций (брендинг криптовалют, ошибки и т.д.)
// и могут требовать отдельной доработки для соответствия дизайн-системе

export const COLORS_WRONG = {
  // Слишком темный, не входит в основную палитру
  darkNavy: '#0E1A27',
  
  // Полностью черный, не в схеме
  black: '#000000',
  
  // Дополнительные оттенки серого
  lightGray: '#F5F5F5',
  disabled: '#9CA3AF',
  border: '#E0E0E0',
  
  // Специфичные текстовые цвета
  grayText: '#536279',
  keypadText: '#141F5C',
  messageText: '#F6F5F5',
  
  // Оранжевый с прозрачностью
  orangeFaded: 'rgba(201, 64, 33, 0.47)',
  
  // Красный для ошибок
  error: '#DC3545',
  errorBg: '#FEE2E2',
  errorBorder: '#FECACA',
  
  // Темный overlay (черный)
  overlayDark: 'rgba(0, 0, 0, 0.6)',
  
  // Брендовые цвета криптовалют
  tether: '#50AF95',
  binance: '#F3BA2F',
  coinbase: '#0052FF',
  
  // Специфичные цвета Google
  googleBlue: '#4285F4',
  googleDark: '#1B203D',
  
  // Другие специфичные цвета
  borderGray: '#A7B0B9',
  backgroundFaded: 'rgba(42, 63, 93, 0.1)',
  whiteFaded: 'rgba(255, 255, 255, 0.2)',
  alertRed: '#F95B38',
  // amountInvalid — насыщенный красный для подсветки невалидного
  // amount input'а (превышение баланса / меньше minimum). Семантически
  // отличается от alertRed (мягкий оранжевый для warning bar'ов):
  // тут это явная ошибка пользовательского ввода, а не предупреждение.
  // Используется на deposit-экранах: Open / TopUp / Outflow / Close.
  amountInvalid: '#CD0A0A',
};
